export const hiddenSkillLineAbilitySpellIds = new Set<number>([
    // Tailoring > Cloth Scavenging
    59390, 343634, 392396,
    // Tailoring > Profession Ranks
    3908, 3909, 3910, 12180, 26790, 51309, 75156, 110426, 158758, 195126,
]);
